import { Component } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { Router, ActivatedRoute } from "@angular/router";
import { PostcodeUsersService } from "./postcodeusers.service";
import { BaseMaterialDatatableComponent } from "@impacgroup/angular-baselib";
import { PostcodeUser } from "../../api-models/PostcodeUser";
import { PostcodeUsersMainComponent } from "./postcodeusers.main.component";

@Component({
    selector: "app-postcodeusers",
    templateUrl: "./postcodeusers.component.html",
    styleUrls: ["postcodeusers.component.scss"],
    standalone: false
})
export class PostcodeUsersComponent extends BaseMaterialDatatableComponent<PostcodeUser> {
    public UTCDATEFORMAT: string = "";

    rows: PostcodeUser[] = [];

    constructor(private postcodeUsersService: PostcodeUsersService, private translateService: TranslateService, private router: Router, private route: ActivatedRoute, parent: PostcodeUsersMainComponent) {
        super({
            stateSaveConfig: {
                stateSaveMode: postcodeUsersService.datatableStateSaveMode,
                stateSaveComponent: parent,
                stateSaveStorageKey: "dtstate_postcodeusers_list",
            },
            sortState: {
                active: "created",
                direction: "desc",
            },
            displayedColumns: ["firstname", "lastname", "email", "created", "updated", "actions"],
            listService: postcodeUsersService,
        });

        this.UTCDATEFORMAT = this.postcodeUsersService.UTCDATEFORMAT;
    }

    showUserPostcodes(id: string) {
        this.router.navigate([id], { relativeTo: this.route });
    }
}
